import Report from './ReportDetailPage';

export default Report;
